export function parseQualityApprovalDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const partNumber = (params.get('partNumber') || '').trim();
  const workTicket = (params.get('workTicket') || '').trim();
  const partIdRaw = params.get('partId');
  const requestIdRaw = params.get('requestId');
  const partId = partIdRaw ? Number(partIdRaw) : null;
  const requestId = requestIdRaw ? Number(requestIdRaw) : null;

  if (!(Number.isFinite(partId) && partId > 0) && !partNumber) {
    return null;
  }

  return {
    partId: Number.isFinite(partId) && partId > 0 ? partId : null,
    requestId: Number.isFinite(requestId) && requestId > 0 ? requestId : null,
    partNumber,
    workTicket,
  };
}
